export const filterByTab = (tab) => {
    return {
        type: 'FILTER_BY_TAB',
        tab
    }
}


// WEBPACK FOOTER //
// ./src/actions/filter.js